module.exports = __webpack_public_path__ + "img/comment-alt-solid.aa43532c.svg";